
import React, { useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SelectContent from './SelectContent';
import MenuContent from './MenuContent';
import CardAlert from './CardAlert';
import OptionsMenu from './OptionsMenu';
import { useDropzone } from 'react-dropzone';
import axios from "axios";
import { AuthContext } from './signin/AuthContext';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu(props) {

  const { username, email, avatar,setAvatar, setToken } = useContext(AuthContext);



    

    React.useEffect(() => {
       
    }, []);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
      accept: 'image/*',
      onDrop: (acceptedFiles) => {
          const reader = new FileReader(acceptedFiles[0]);
          var file = ''
          reader.onload = () => {
              const binaryBuffer = new Uint8Array(reader.result);
              const formData = new FormData();
              const base64String = reader.result;
              setAvatar(base64String);

              axios({
                  method: "POST",
                  url:"/upload_avatar",
                  data: {base64String},
                  headers: {
                      'Access-Control-Allow-Origin': '*',
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',

                      'Method': 'POST',
                  },
              })
                  .then((response) => {


                  }).catch((error) => {
                  if (error.response) {
                      console.log(error.response)
                      console.log(error.response.status)
                      console.log(error.response.headers)
                  }
              });}
          reader.readAsDataURL(acceptedFiles[0]);

      },
  });

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',

          p: 1.5,
        }}
      >
        <SelectContent />
      </Box>
      <Divider />
      <MenuContent />
        {/*
      <CardAlert />
      */}
        <Stack
            direction="row"
            sx={{
                p: 2,
                gap: 1,
                alignItems: 'center',
                borderTop: '1px solid',
                borderColor: 'divider',
            }}
        >

             <Avatar
            sizes="small"
            alt="Grower"
            src={avatar}
            sx={{width: 50, height: 50}}
            {...getRootProps()} className="dropzone"

        />

            <input {...getInputProps()}     style={{display: "none",
            position: "absolute",
            height: "40px",
            width: "40px"}} />


            <Box sx={{mr: 'auto'}}>
                <Typography variant="body2" sx={{fontWeight: 500, lineHeight: '16px'}}>
                    {username}
                </Typography>
                <Typography variant="caption" sx={{color: 'text.secondary'}}>
                    {email}
                </Typography>
            </Box>
            <OptionsMenu removeToken={props.removeToken}/>
        </Stack>
    </Drawer>
  );
  }
